import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { LayoutComponent } from './layout.component'
import { HeaderModule } from '../../core/layout/header/header.module'
import { LoadingBarModule } from '@ngx-loading-bar/core'
import { LoadingBarRouterModule } from '@ngx-loading-bar/router'

/**
 * LayoutModule - Contains layout components for authenticated app shell
 *
 * Provides:
 * - LayoutComponent (main layout wrapper with header + content)
 * - Loading bar for route transitions
 */
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HeaderModule,
        LoadingBarModule,
        LoadingBarRouterModule
    ],
    declarations: [
        LayoutComponent
    ],
    exports: [
        LayoutComponent
    ]
})
export class LayoutModule {}
